import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService, DataService } from '@app/services';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
    
    constructor (
        private router: Router,
        private authService : AuthService,
        private dataService : DataService
    ) {}
    
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {  
            let token = route.queryParamMap.get('token');
            if(token && token != ''){
                return true;
            }
            else{
                return this.checkTokenLogin();
            }
    }
    
    async checkTokenLogin() {  
        let loggedUser = await this.authService.checkTokenUser(false);
        if(loggedUser !== null){
            return this.router.parseUrl('home');
        }
        else{           
            return true;
        }  
    }
}
